import React from 'react'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import ThingsToKnow from './ThingsToKnow'
import VoipChangePlanForm from '../forms/VoipChangePlanForm'
import PaymentInformation from './PaymentInformation'
import DataSource from '../DataSource'
import globals from '../globals'

class ChangePlanVoip extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            hasError: false,
            plans: []
        }
    }

    componentDidMount () {
        if (this.props.serviceDetails && this.props.serviceDetails.planId) {
            this.getPlans()
        }
    }

    componentDidUpdate (prevProps) {
        if (prevProps.serviceDetails !== this.props.serviceDetails) {
            this.getPlans()
        }
    }

    getPlans () {
        if (this.state.plans.length === 0) {
            DataSource.getData(`/api/getVoipPlans/${this.props.serviceDetails.planId}`, result => {
                this.setState({
                    plans: result.plans,
                    isLoaded: true
                })
            }, () => {
                this.setState({ hasError: true, isLoaded: true })
            })
        }
    }

    handleSuccess (response, state) {
        globals.pushEvent('VoipChangePlan', { planName: state.planName })
    }

    render () {
        return (
            <div>
                <div className='change-plan-voip module'>
                    <Heading title={this.props.title} />
                    <ModuleWithLoader isLoaded={this.state.isLoaded} hasError={this.state.hasError}>
                        <div className='p-4'>
                            <div className='row'>
                                <div className='col-12 col-md-8 offset-md-2 text-center'>
                                    <p>Changing plan between Pay-as-you-go and Unlimited Home Phone is super-quick and easy. Simply choose your no lock-in plan below. And changing plan is free.</p>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-12 col-md-8 offset-md-2'>
                                    <VoipChangePlanForm
                                        serviceId={this.props.serviceId}
                                        serviceDetails={this.props.serviceDetails}
                                        plans={this.state.plans}
                                        handleSuccess={this.handleSuccess.bind(this)}
                                    />
                                </div>
                            </div>
                        </div>
                    </ModuleWithLoader>
                </div>
                <PaymentInformation />
                <ThingsToKnow type='changePlanVoip' />
            </div>
        )
    }
}

export default ChangePlanVoip



// WEBPACK FOOTER //
// ./resources/js/modules/ChangePlanVoip.js